import React, { Component } from "react";
import { Icon as LegacyIcon } from "@ant-design/compatible";
import { Button, message } from "antd";
import PropTypes from "prop-types";
import collect from "collect.js";
import { prefixFile } from "../fetch/fetchApi";

class ExportBtn extends Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentDidMount() {}

  handleExport = () => {
    const {
      serviceName,
      fileName,
      // isEncodeURI = true,
      tableKey,
      needPagination = false,
      handleParams,
      checkParams,
    } = this.props;

    let param = this.props.param ? JSON.parse(JSON.stringify(this.props.param)) : "";
    if (tableKey) {
      const gridContext = this.context.store.getState().gridsInfo.context[tableKey];
      console.log("handleParams", handleParams);
      if (handleParams) {
        param = JSON.parse(JSON.stringify(handleParams(gridContext.params)));
      } else {
        param = JSON.parse(JSON.stringify(gridContext.params));
      }
      const tableData = gridContext.state.gridData;
      if (!tableData || tableData.length === 0) {
        message.error("没有数据");
        return;
      }
    }
    Object.keys(param).forEach((key) => {
      if (typeof param[key] === "number") {
        param[key] = `${param[key]}`;
      }
    });
    // for (const key in param) {
    //   if (typeof param[key] === "number") {
    //     param[key] = `${param[key]}`;
    //   }
    // }
    if (!needPagination) {
      delete param.page;
      delete param.pagecount;
    }
    delete param.isBtnSearch;

    if (checkParams) {
      if (!param[checkParams.value]) {
        message.error(`请选择查询条件: ${checkParams.text}`);
        return;
      }
    }

    const paramJson = collect(param).toJson();
    // let exportUrl =
    // `${prefixFile}/export.do
    // ?serviceName=${serviceName}&fileName=${fileName}&searchJson=${paramJson}`;
    const exportUrl = `${prefixFile}/export.do?serviceName=${encodeURIComponent(
      serviceName,
    )}&fileName=${encodeURIComponent(fileName)}&searchJson=${encodeURIComponent(paramJson)}`;
    const alink = document.createElement("a");
    const evt = document.createEvent("MouseEvents");
    alink.href = exportUrl;
    if (document.all) {
      alink.click();
    } else {
      evt.initEvent("click", true, true);
      alink.dispatchEvent(evt);
    }
  };

  render() {
    return (
      <Button type="primary" icon={<LegacyIcon type="export" />} onClick={this.handleExport}>
        导出
      </Button>
    );
  }
}

export { ExportBtn };



// WEBPACK FOOTER //
// ./src/AntD/utils/exportBtn.js